export default function (value) {

    let tmp = parseFloat(value);
    console.log(tmp);
    let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return formatter.format(tmp);
}
